var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalClientsLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FFF5CD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.13086 22.5576H18.4987M18.4987 22.5576V14.3948C19.0975 14.6008 20.5089 14.9563 21.1807 15.2499C21.8728 15.5524 22.0748 16.4055 22.0748 17.213V22.5576M18.4987 22.5576H22.0748M22.8686 22.5576H22.0748",
    stroke: "#9A842C",
    strokeWidth: 1.0435,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78711 22.0702V12.3367C9.78711 10.6578 9.78711 9.8176 10.3162 9.40087C10.8453 8.98414 11.6246 9.2109 13.1838 9.66308L16.5284 10.6337C17.4688 10.9066 17.9391 11.043 18.2107 11.4156C18.4829 11.7875 18.4829 12.2939 18.4829 13.308V22.0702",
    stroke: "#9A842C",
    strokeWidth: 1.00336,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1318 13.8638H15.1385M13.1318 16.5394H15.1385M15.8074 22.4748V20.5529C15.8074 19.922 15.8074 19.607 15.6114 19.411C15.4154 19.215 15.1004 19.215 14.4696 19.215H13.8007C13.1699 19.215 12.8549 19.215 12.6589 19.411C12.4629 19.607 12.4629 19.922 12.4629 20.5529V22.4953",
    stroke: "#9A842C",
    strokeWidth: 1.00336,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalClientsLight);
export default __webpack_public_path__ + "static/media/Total_Clients_Light.694761d9dd38ed68ee46125d23115253.svg";
export { ForwardRef as ReactComponent };